
import Vue from "vue"
import type { Session } from "@/types/session"

export default Vue.extend({
  props: {
    timestamp: {
      type: Number,
      default: 0,
    },
    session: {
      type: Object as VuePropType<null | Session>,
      default: null,
    },
    shortPattern: {
      type: String,
      default: "HH:mm",
    },
    verbosePattern: {
      type: String,
      default: "Do MMM YYYY HH:mm:ss z",
    },
  },

  computed: {
    startFinish (): number[] {
      return (["start", "finish"] as const).map(this.sF)
    },

    title (): string {
      return this.formatVerbose(this.timestamp || this.sF("start"))
    },

    datetime (): string {
      const { timestamp } = this
      return timestamp
        ? this.$moment(timestamp).toISOString()
        : this.startFinish.map(d => this.$moment(d).toISOString()).join("/")
    },

    time (): string {
      const { timestamp, formatShort } = this
      return timestamp
        ? formatShort(timestamp)
        : this.startFinish.map(formatShort).join(" — ")
    },
  },

  methods: {
    formatShort (timestamp: number): string {
      return this.$fmt.date(timestamp, this.shortPattern)
    },
    formatVerbose (timestamp: number): string {
      return this.$fmt.date(timestamp, this.verbosePattern)
    },

    sF (key: "start" | "finish"): number {
      return this.session?.[key] || 0
    },
  },
})
